var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message py-2",class:{
    'message-error': _vm.type === 'error',
    'message-information': _vm.type === 'information',
    'message-warning': _vm.type === 'warning',
    'message-success': _vm.type === 'success',
    'border-none': _vm.borderless,
    'text-sm px-2 py-1 sm:px-2 sm:py-1': _vm.small,
    'sm:py-3 px-3 sm:px-4': !_vm.small && !_vm.large,
    'pr-6': _vm.dismissible,
    'px-4 py-3': _vm.large,
    rounded: _vm.rounded
  },on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.showIcon)?_c('FontAwesomeIcon',{staticClass:"icon mr-1",attrs:{"icon":_vm.compIcon,"fixed-width":""}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.dismissible)?_c('a',{on:{"click":function($event){return _vm.dismiss()}}},[_c('FontAwesomeIcon',{staticClass:"message-close",attrs:{"icon":_vm.faTimes}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }